import React, { useState, useEffect, useRef } from "react";

import {
    Typography,
    TextField,
    Button,
    Container,
    useTheme,
    useMediaQuery,
    MenuItem,
    InputAdornment,
    OutlinedInput,
    Autocomplete,
    Select,
    FormControl,
    InputLabel,
    Grid,
    Paper,
    Box,
    FormGroup,
    List,
    ListItem,
    ListItemText,
    Popover,
    Menu,
    Tab,
    Tabs,
    Card,
    CardContent,
} from "@mui/material";
// import { colorTokens } from "../../../theme";
import { setCsrfToken, setLogin, setUserDetail } from "../../../state";
import { useSelector, useDispatch } from "react-redux";
import { BorderAllRounded } from "@mui/icons-material";

import cameraIcon from ".//picture/camera.png"; 
import checkIcon from ".//picture/check.png";
import emailIcon from ".//picture/email.png";
import pencilIcon from ".//picture/pencil.png";
import phoneIcon from ".//picture/phone-call.png";
import userBIcon from ".//picture/userblack.png"; 
import userWIcon from ".//picture/userwhite.png";



const TabAccount = ({ userDetail, colors, isMobile, activeTab }) => {
    const dispatch = useDispatch();
    //   const theme = useTheme();
    //   const colors = colorTokens(theme.palette.mode);
    //   const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
    const [localUserDetail, setLocalUserDetail] = useState(userDetail);
    const handleChangeInput = (e) => {
        const { name, value } = e.target;
        setLocalUserDetail((prevData) => ({ ...prevData, [name]: value }));
    };

    const [isEditProfile, setIsEditProfile] = useState(false);
    const handleEditProfile = (e) => {
        const { name, value } = e.target;
        if (name == "edit_profile") {
            setIsEditProfile(true);
        } else {
            setIsEditProfile(!isEditProfile);
            // dispatch(setUserDetail({
            //     img_src: "",
            //     fullname: userData.data.firstname + " " + userData.data.lastname,
            //     firstname: userData.data.firstname,
            //     lastname: userData.data.lastname,
            //     email: userData.data.email,
            //     app_id: userData.data.app_id,
            //     user_type: userData.data.user_type
            //   }));
        }
    };
    const [isUpdateEmail, setIsUpdateEmail] = useState(false);

    useEffect(() => {
        // console.log(activeTab)
    }, [activeTab]);

    return (
        <Grid container justifyContent="center" alignItems="center">

            <Grid container justifyContent="center" alignItems="center" marginBottom={3}>
                <Grid item xs={6} md={9}>
                    {isEditProfile ? (
                        <Box 
                            display="flex"
                            flexDirection="column"
                            sx={{
                                width: '100%',
                                // backgroundColor: '#2E3343',
                                padding: 3,
                            }}
                        >
                            <Typography variant="h2" marginBottom={3} color="white" sx={{ textAlign: 'left' }}>Edit Profile</Typography>
                        <Box 
                            display="flex" 
                            flexDirection="column" 
                            alignItems="center"
                        >
                            <Box
                                sx={{
                                width: 90,
                                height: 90,
                                borderRadius: '50%',
                                backgroundColor: "#D0D0D0",
                                padding: "30px",
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                marginBottom: 1,
                                }}
                            >
                                <img 
                                    src={userBIcon} 
                                    alt="User" 
                                    style={{ width: 70, height: 70 }} 
                                />
                            </Box>

                            <Typography variant="h4" color="white">Change Photo</Typography>
                            
                            </Box>
                        </Box>
                    
                    ) : (
                        <Box 
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            sx={{
                                width: '100%', 
                                backgroundColor: '#202431',
                                padding: 3,
                            }}
                        >
                            <Box display="flex" flexDirection="column">
                                <Typography variant="h2" marginBottom={2}>My Account</Typography>
                                    <Box display="flex" alignItems="center" marginBottom={1}>
                                        <Typography variant="h4" style={{ marginRight: 8 }}>Account Verified</Typography>
                                        <img 
                                            src={checkIcon}
                                            style={{ width: 20, height: 20 }} 
                                        />
                                    </Box>
                                <Typography variant="h4">Last Login: 13 May 2025, 14:32</Typography>
                            </Box>
                            <Box
                                sx={{
                                    width: 90,
                                    height: 90,
                                    borderRadius: '50%', 
                                    backgroundColor: "#D0D0D0", 
                                    padding: "30px", 
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}
                            >
                                <img 
                                    src={userBIcon} 
                                    style={{ width: 70, height: 70}} 
                                />
                            </Box>
                        </Box>                   
                        
                    )}
                </Grid>
            </Grid>
            <Card
                sx={{
                    width: '100%',
                    height: '100vh',
                    display: 'flex',
                    justifyContent: 'center',
                    backgroundColor: '#2E3343',          
                }}
            >
                <CardContent sx={{ width: '45%', marginTop: 10, paddingY: 0, paddingX: 0 }}>

                    {/** row ================================================================================================================================== */}
                    <Grid container justifyContent="space-between" alignItems="center" marginBottom={6}>
                        <Grid item xs={2} md={2}>
                            <Box 
                                display="flex" 
                                alignItems="center"  
                                justifyContent="center"                             
                            >
                                <img 
                                    src={userWIcon} 
                                    style={{ width: 34, height: 34}}  
                                />
                            </Box>
                        </Grid> 

                        <Grid item xs={5} md={5}>  
                            <Box 
                                display="flex" 
                                alignItems="center"
                                justifyContent="center"  
                                sx={{ width: '100%' }}
                            >                
                                <Box sx={{ width: 160 }}>
                                    <TextField
                                        fullWidth
                                        label="First Name"
                                        name="firstname"
                                        value={localUserDetail?.firstname}
                                        onChange={handleChangeInput}
                                        size="small"
                                        InputProps={{
                                            readOnly: !isEditProfile,
                                            sx: {
                                                fontSize: 20,
                                                backgroundColor: '#D9D9D9',
                                                borderRadius: 20,
                                                color: 'black',
                                                textAlign: 'center'
                                            }
                                        }}
                                        InputLabelProps={{
                                            shrink: true,
                                            sx: {
                                                fontSize: 20,
                                                top: '-12px'
                                            },
                                        }}
                                    />
                                </Box>
                            </Box>
                        </Grid>

                        <Grid item xs={5} md={5}>
                            <Box 
                                display="flex" 
                                alignItems="center"
                                justifyContent="center"  
                                sx={{ width: '100%' }}
                            >
                                <Box sx={{ width: 160 }}>
                                    <TextField
                                        fullWidth
                                        label="Last Name"
                                        name="lastname"
                                        value={localUserDetail?.lastname}
                                        onChange={handleChangeInput}
                                        size="small"
                                        InputProps={{
                                            readOnly: !isEditProfile,
                                            sx: {
                                                fontSize: 20,
                                                backgroundColor: '#D9D9D9',
                                                borderRadius: 20,
                                                color: 'black',
                                                textAlign: 'center'
                                            }
                                        }}
                                        InputLabelProps={{
                                            shrink: true,
                                            sx: {
                                                fontSize: 20,
                                                top: '-12px'
                                            },
                                        }}
                                    />
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>

                    {/** row ================================================================================================================================== */}
                    <Grid container alignItems="space-evenly" marginBottom={6} marginLeft={2}> 
                        <Grid item xs={6} md={6}>
                            <Box 
                                display="flex" 
                                alignItems="center"
                                justifyContent="center"
                                sx={{ width: '100%' }}
                            >
                                <img 
                                    src={emailIcon} 
                                    style={{ width: 40, height: 40, marginRight: 33 }} 
                                />
                                <TextField
                                    fullWidth
                                    label="Email"
                                    name="email"
                                    margin="normal"
                                    value={localUserDetail?.email}
                                    onChange={handleChangeInput}
                                    size="small"
                                    InputProps={{
                                        readOnly: !isUpdateEmail,
                                        sx: {
                                            fontSize: 20,
                                            width: 350,
                                            paddingLeft: '8px',
                                            backgroundColor: '#D9D9D9',
                                            borderRadius: 20,
                                            color: 'black',   
                                            textAlign: 'center'                         
                                        }
                                    }}
                                    InputLabelProps={{ // label text                                        
                                        shrink: true,
                                        sx: {
                                            fontSize: 20,
                                            top: '-12px',
                                        },
                                    }}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                    {/** row ================================================================================================================================== */}
                    <Grid container alignItems="space-evenly" marginBottom={6} marginLeft={2}>
                        <Grid item xs={6} md={6}>
                            <Box 
                                display="flex" 
                                alignItems="center"
                                justifyContent="center"
                                sx={{ width: '100%' }}
                            >
                                <img 
                                    src={phoneIcon} 
                                    style={{ width: 36, height: 36, marginRight: 33, marginLeft: 3 }} 
                                />
                                <TextField
                                    fullWidth
                                    label="Phone Number"
                                    name="phonenumber"
                                    margin="normal"
                                    value={localUserDetail?.phonenumber}
                                    onChange={handleChangeInput}
                                    size="small"
                                    InputProps={{
                                        readOnly: !isEditProfile,
                                        sx: {
                                            fontSize: 20,
                                            width: 350,
                                            paddingLeft: '8px',
                                            backgroundColor: '#D9D9D9',
                                            borderRadius: 20,
                                            color: 'black',                       
                                        }
                                    }}
                                    InputLabelProps={{
                                        shrink: true,
                                        sx: {
                                            fontSize: 20,
                                            top: '-12px',
                                        },
                                    }}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                    {/** row ================================================================================================================================== */}
                    <Grid container justifyContent="space-evenly" alignItems="center" sx={{ display: 'flex' }}> 
                    <Grid item xs={5} md={5}>
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                margin: 8
                            }}
                        >
                            {!isEditProfile ? (
                                <Button
                                    name="edit_profile"
                                    variant="contained"
                                    size={isMobile ? "small" : "medium"}
                                    sx={{
                                        boxSizing: 'border-box',
                                        fontWeight: 'bold',
                                        fontSize: isMobile ? '16px' : '20px',
                                        textTransform: "none",
                                        backgroundColor: 'transparent',
                                        borderRadius: 20,
                                        border: '2px solid #F7F7F7',
                                        padding: '7px 12px',
                                        margin: '10px',
                                        width: '150px',
                                        flexShrink: 0,
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                        transition: 'all 0.3s ease-in-out',
                                        "&:hover": {
                                            border: '2px solid transparent',
                                            boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
                                            backgroundColor: '#F7F7F7',
                                        },

                                        "&:hover .icon": {
                                            filter: 'brightness(0) saturate(100%)',
                                            transition: 'filter 0.3s ease-in-out',
                                        },
                                    }}
                                    startIcon={<img src={pencilIcon} className="icon" style={{ width: 13, height: 13, paddingLeft: 3}} />}
                                    
                                    onClick={handleEditProfile}
                                >
                                    Edit Profile
                                </Button>
                            ) : (
                            <>
                                <Button
                                    name="save"
                                    variant="contained"
                                    size={isMobile ? "small" : "medium"}
                                    sx={{
                                        boxSizing: 'border-box',
                                        fontWeight: 'bold',
                                        fontSize: isMobile ? '16px' : '20px',
                                        textTransform: "none",
                                        backgroundColor: 'transparent',
                                        borderRadius: 20,
                                        border: '2px solid #F7F7F7',
                                        padding: '7px 12px',
                                        margin: '10px',
                                        width: '150px',
                                        flexShrink: 0,
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                        transition: 'all 0.3s ease-in-out',
                                        "&:hover": {
                                            border: '2px solid transparent',
                                            boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
                                            backgroundColor: '#F7F7F7',
                                        },
                                    }}
                                    onClick={handleEditProfile}
                                >
                                Save
                                </Button>
                                <Button
                                    name="cancel_edit_profile"
                                    variant="contained"
                                    size={isMobile ? "small" : "medium"}
                                    sx={{
                                        boxSizing: 'border-box',
                                        fontWeight: 'bold',
                                        fontSize: isMobile ? '16px' : '20px',
                                        textTransform: "none",
                                        backgroundColor: 'transparent',
                                        borderRadius: 20,
                                        border: '2px solid #F7F7F7',
                                        padding: '7px 12px',
                                        margin: '10px',
                                        width: '150px',                                        
                                        flexShrink: 0,
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                        transition: 'all 0.3s ease-in-out',
                                        "&:hover": {
                                            border: '2px solid transparent',
                                            boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
                                            backgroundColor: '#F7F7F7',
                                        },
                                    }}
                                    onClick={handleEditProfile}
                                >
                                Cancel
                                </Button>
                            </>
                            )}
                        </Box>
                    </Grid>
                    </Grid>
                    {/** row ================================================================================================================================== */}
                </CardContent>
            </Card>
        </Grid>
    );
};

export default TabAccount;
